import { Button } from 'react-aria-components'
import toast, { type Toast } from 'react-hot-toast'

import { css, cva } from '@portal/styled-system/css'

const toastRecipe = cva({
    base: {
        width: '[21.25rem]',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: '2',
        borderRadius: 'medium',
        border: '[1px solid]',
        fontFamily: 'montserrat',
        fontWeight: 'medium',
        color: 'white',
        paddingY: '2',
        paddingX: '3',
        whiteSpace: 'pre-line',
        boxShadow: '[0 4px 8px 0 rgba(54, 58, 69, 0.20)]',
    },
    variants: {
        variant: {
            success: { backgroundColor: 'success', borderColor: 'success.600' },
            error: { backgroundColor: 'danger', borderColor: 'danger.600' },
        },
        animation: {
            'toast-in': { animationStyle: 'toast-in' },
            'toast-out': { animationStyle: 'toast-out' },
        },
    },
})

type ToastViewProps = {
    toastData: Toast
    variant: 'success' | 'error'
    message: string
}

export function ToastView({ variant, toastData, message }: ToastViewProps) {
    return (
        <div className={toastRecipe({ variant, animation: toastData.visible ? 'toast-in' : 'toast-out' })}>
            {message}
            <ToastCloseButton onClick={() => toast.dismiss(toastData.id)} />
        </div>
    )
}

function ToastCloseButton({ onClick }: { onClick: () => void }) {
    return (
        <Button
            data-dismiss="modal"
            aria-label="Close"
            onPress={onClick}
            className={css({
                borderStyle: 'none', // reset
                outline: 'none', // reset
                backgroundColor: 'transparent', // reset
                width: '3',
                height: '3',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                color: 'white',
                fontSize: '[0.75rem]',
                lineHeight: 'none',
            })}
        >
            <i className="fa-solid fa-xmark-large" />
        </Button>
    )
}

export const toastView = ({ toastData, variant, message }: ToastViewProps) => (
    <ToastView toastData={toastData} variant={variant} message={message} />
)
